import List from '../DataList';
export default List;